import { render } from "./privatePolicy.vue?vue&type=template&id=193b1df1&scoped=true&lang=html"
import script from "./privatePolicy.vue?vue&type=script&lang=js"
export * from "./privatePolicy.vue?vue&type=script&lang=js"

import "./privatePolicy.vue?vue&type=style&index=0&id=193b1df1&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193b1df1"]])

export default __exports__